import React, {Component} from 'react'
import '../../../styles/Admin.css'
import Dropzone from "react-dropzone";
import {Button} from "react-bootstrap";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import firebase from "../../../../firebase";
import Crop from "./Crop";
import {NotificationManager} from "react-notifications";

export default class AdminAktualnosci extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data2: [],
            opis: '',
            rozmiar: '',
            zdjecie: '',
            zdjecieShow: [],
            catalog: {value: 1, label: 'Katalog główny'},
            catalogName: '',
            catalogOptions: [],
            opublikowano: false,
        };

        this.handleCatalogSelect = this.handleCatalogSelect.bind(this);
        this.handleCatalogName = this.handleCatalogName.bind(this);
        this.handleOpisChange = this.handleOpisChange.bind(this)
    }

    componentDidMount() {
        // this.getCatalogs()
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            tresc: editorState,
        });
    };

    handleCatalogSelect(e) {
        this.setState({catalog: e})
    }

    handleCatalogName(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    handleOpisChange(e) {
        this.setState({opis: e.target.value})
    }

    // getCatalogs() {
    //     let catalog = []
    //     catalog.push({value: 1, label: 'Katalog główny'})
    //     const itemsRef = firebase.database().ref('pliki');
    //     itemsRef.on('value', (snapshot) => {
    //         let items = snapshot.val();
    //         for (let item in items) {
    //             if (items[item].length !== undefined) {
    //                 catalog.push({value: items[item][0].name, label: items[item][0].name})
    //             }
    //         }
    //     });
    //     catalog.push({value: 'nowy', label: 'Dodaj nowy folder... ', disabled: false})
    //     this.setState({catalogOptions: catalog})
    // }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({zdjecieInvalid: true, zdjecie: ''});
            NotificationManager.error("", "Niepoprawny plik zdjęcia ", 5000)
        } else {
            this.getBase64(accepted);
            this.setState({
                zdjecieInvalid: false,
                zdjecie: accepted,
                opis: accepted[0].name,
                rozmiar: (accepted[0].size / 1024).toFixed(2) + 'kb'
            })
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({zdjecieShow: reader.result})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    deleteImage(image) {
        let images = this.state.zdjecieShow;
        images = images.filter(el => el !== image);
        this.setState({zdjecieShow: images})
    }

    // addNewCatalog() {
    //     const itemsRef = firebase.database().ref('pliki');
    //     const item = [{
    //         name: this.state.catalogName,
    //         files: [{
    //             id: parseInt(Math.random() * 100),
    //             autor: 'ADMIN',
    //             data: moment().add(2, 'hours').toISOString(),
    //             zdjecia: {src: this.state.zdjecieShow, name: this.state.opis, rozmiar: this.state.rozmiar}
    //         }]
    //     }]
    //     itemsRef.push(item);
    //     this.props.goZarzadzanie()
    // }
    //
    // uploadNewsToCatalog() {
    //     const itemsRef = firebase.database().ref('pliki');
    //     itemsRef.on('value', (snapshot) => {
    //         let items = snapshot.val();
    //         let getItem = []
    //         let itemId
    //         for (let item in items) {
    //             if (items[item].length !== undefined) {
    //                 console.log(items[item])
    //                 if (items[item][0].name === this.state.catalog.label) {
    //                     itemId = item
    //                     getItem = items[item]
    //                     console.log(getItem)
    //                     getItem[0].files.push({
    //                         id: parseInt(Math.random() * 100),
    //                         autor: 'ADMIN',
    //                         data: moment().add(2, 'hours').toISOString(),
    //                         zdjecia: {src: this.state.zdjecieShow, name: this.state.opis, rozmiar: this.state.rozmiar}
    //                     })
    //                     console.log(getItem)
    //                     const itemsRef = firebase.database().ref(`/pliki/${itemId}`);
    //                     itemsRef.set(getItem);
    //                 }
    //             }
    //         }
    //     });
    //     this.props.goZarzadzanie()
    // }

    // uploadNews() {
    //     const itemsRef = firebase.database().ref('pliki');
    //     const item = {
    //         id: parseInt(Math.random() * 100),
    //         autor: 'ADMIN',
    //         data: moment().add(2, 'hours').toISOString(),
    //         zdjecia: {src: this.state.zdjecieShow, name: this.state.opis, rozmiar: this.state.rozmiar}
    //     }
    //     itemsRef.push(item);
    //     this.props.goZarzadzanie()
    // }

    render() {
        return <div className="aktualnosciTabContainer">

            <div className="aktualnosciOpis">
                Aby dodać nowy plik należy przeciągnąć plik do poniższego pola lub kliknąć na nie by otworzyć
                przeglądarkę plików. Plikiem można później zarządzać przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            {this.state.cropTrue ?
                <Crop cropItem={this.state.cropItem}
                      setImage={(image) => this.props.setImage(image, this.state.zdjecie)} zdjecie={this.state.zdjecie}
                      closeModal={() => this.props.closeModal()} anuluj={() => this.setState({cropTrue: false})}/>
                :
                <div className="nowyWpisForm">
                    <div className="field">
                        <div className="row">
                            <div className="col-sm-12">
                                Dodaj zdjęcia:
                                <Dropzone maxSize={2000000} accept="image/*" multiple={false}
                                          style={{
                                              maxWidth: '100%',
                                              height: 150,
                                              border: '1px dashed #ced4da',
                                              borderRadius: '0.25rem',
                                              paddingTop: 15,
                                              textAlign: 'center',
                                              fontSize: '0.875rem',
                                              color: '#565756',
                                              cursor: 'pointer'
                                          }}
                                          onDrop={(accepted, rejected) => {
                                              this.onDrop(accepted, rejected)
                                          }}>
                                    <div>

                                        <div>{this.state.zdjecie.length === 0 ? <div style={{color: '#007bff'}}>
                                            <div style={{paddingTop: '2%'}}>Kliknij lub przeciągnij by dodać plik</div>
                                            <div>Akceptowane pliki .jpg / .png</div>
                                            <div>Maksymalny rozmiar 2mb</div>
                                        </div> : <div>
                                            <div>
                                                <div><img src={this.state.zdjecie[0].preview}
                                                          style={{maxWidth: 100, maxHeight: 100}}/></div>
                                            </div>
                                            <div>Załadowano: {this.state.zdjecie[0].name}</div>
                                        </div>}</div>

                                    </div>
                                </Dropzone>
                                <div style={{paddingTop: 10}}>Nazwa (opcjonalnie):</div>
                                <input type="text" className="form-control" name="opis" value={this.state.opis}
                                       onChange={this.handleCatalogName}/>
                                <Button bsStyle={'success'}
                                        disabled={this.state.zdjecie === '' || (this.state.catalog.value === 'nowy' && this.state.catalogName.length === 0)}
                                        style={{
                                            float: 'right',
                                            marginTop: '10px',
                                            width: '15%',
                                            color: 'white'
                                        }}
                                        onClick={this.props.modal ? (this.props.crop ? () => {
                                            this.setState({
                                                cropTrue: !this.state.cropTrue,
                                                cropItem: this.state.zdjecieShow
                                            });
                                        } : () => this.props.wybierzObraz(this.state.zdjecie)) : null}>Dodaj</Button>
                            </div>
                        </div>
                    </div>
                </div>}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/galeriaComponents/NowyPlik.js